import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER, IS_PAID_USER } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

export const crossPromoVkMusicFakedoor: 'a' | 'b' | 'c' | 'd' =
    IS_PAID_USER && !IS_MOBILE_BROWSER && getFeature('cross-promo-vk-music-fakedoor');

export const crossPromoVkMusicFakedoorTariff: string = getFeature('cross-promo-vk-music-fakedoor-tariff');

if (IS_PAID_USER && !IS_MOBILE_BROWSER) {
    registerExperiment('vk-mus-fake', crossPromoVkMusicFakedoor, [
        AnalyticEventNames.CROSS_PROMO_VK_MUSIC_FAKEDOOR_SHOW,
        AnalyticEventNames.CROSS_PROMO_VK_MUSIC_FAKEDOOR_CLICK,
        AnalyticEventNames.CROSS_PROMO_VK_MUSIC_SEVERAL_SUBSCRIPTIONS_SHOW,
        AnalyticEventNames.CROSS_PROMO_VK_MUSIC_SEVERAL_SUBSCRIPTIONS_CLICK,
    ]);
}
